var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubstrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 177.07 203.18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.58 200.16-2.66 1.53.48.28 2.18-1.26v2.47l88.49-51.09v-5.52l-88.49 51.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m88.58 183.37-17.2 9.93.84.48 16.36-9.44v2.08l88.49-51.09v-5.13l-88.49 51.09z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m88.58 166.59-31.73 18.32 1.2.69 30.53-17.63v1.66l88.49-51.09v-4.71l-88.49 51.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m676.63 341-1.3-.75-70.87 40.91-9.19-5.31 21.53-12.45v-3.12l46.63-26.92-2.28-1.31-44.35 25.6v-2.65l-28.8 16.62-10-5.74 70.89-40.88-1.89-1.14-70.86 40.91-9.67-5.58 15.71-9.07-2.94-1.7 55.15-31.84-1.56-.9-55.15 31.84-2.8-1.61-15.78 9.09v3.25l-14.77 8.52-1.07-.62-43.7 25.23v4.3l47.44-27.4-1.08-.63 13.18-7.65v3.35l9.72 5.61-10.29 5.93-.71-.41-58.26 33.64v3.88l61.62-35.58-.72-.42 10.28-5.93 9.94 5.73-21.58 12.49v2.26l-59.54 34.38v3.47l59.54-34.4v2.65l9.24 5.33-68.78 39.72v1.49l1.34.78 70.1-40.44 9.56 5.52-21.46 12.26v2.81l-46.3 26.74 2.28 1.31 44-25.42v3.25l28.92-16.66 8.72 5-8.56 4.94v.84l-60.8 35.1 1.92 1.11 58.88-34v.83l11.92-6.88 9.46 5.46-15.44 8.91 1.36.78-7.3 4.22v1.25l-46.26 26.71 1.56.9 44.7-25.81v1.3l11-6.36 2.22 1.28 15.42-8.92v-2.58l59.83-34.54v-4.29l-59.83 34.54v-1.57l-9.45-5.46 69.28-40v-3.88l-72.63 41.94-8.72-5 21.53-12.43v-2.84l59.83-34.54v-3.46l-59.84 34.5v-2.12l-9.69-5.6 69.52-40.14zm-110.19 51.5 21.56-12.45 9.2 5.31-10.26 5.92-11.27 6.51zm43.07 0-21.64 12.37-9.59-5.54 9.9-5.71 11.63-6.71z",
    transform: "translate(-499.56 -291.13)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m31.78 68.15 88.49-51.09-1.2-.69-88.49 51.09-1.44-.83-29.14 16.82v4.72l33.23-19.19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.22 59.77 88.51-51.1-.84-.49-88.51 51.1-1.8-1.03-14.58 8.42v5.13l19.03-10.99z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m2.67 51.39 88.52-51.11-.47-.28-88.54 51.11-2.16-1.24-.02.01v5.55l4.83-2.79z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstrate);
export default __webpack_public_path__ + "static/media/substrate.96d5420f48a6f2f97ada18ce79750ec7.svg";
export { ForwardRef as ReactComponent };